// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3578":"f56c09e1","9833":"568d051f"}[chunkId] + ".chunk.css";
};